import { addPermissionsToRoute } from '@/myq-core/';

const routes = {
  name: 'Service',
  icon: 'mdi-hand-heart-outline',
  path: '/reports/mcd/service/',
  children: [
    {
      path: '/reports/mcd/service/serviceTimesStatistics',
      name: 'Service Time Statistics',
      meta: { id: 'reports-serviceTimesStatistics' },
      component: () => import('./ServiceTimeStats.vue'),
      ...addPermissionsToRoute(['serviceTimesStatistics']),
      tags: [
        'Drive Thru Times',
        'KVS Prep Times Box Whisker View',
        'Expeditor Times Box Whisker View',
        'Daily Drive Thru TTL',
        'Drive Thru Multi-Day Trend',
      ],
    },
    {
      path: '/reports/mcd/service/MOPServiceTimes',
      name: 'MOP Service Times',
      meta: { id: 'reports-mobileServiceTimes' },
      component: () => import('./MOPServiceTimes.vue'),
      ...addPermissionsToRoute(['mobileServiceTimes']),
    },
    {
      path: '/reports/mcd/service/yynn',
      name: 'YYNN',
      meta: { id: 'reports-YYNN' },
      component: () => import('./yynn/YYNN.vue'),
      ...addPermissionsToRoute(['YYNN']),
      tags: ['yy', 'nn', 'Drive Thru Trend'],
    },
    {
      path: '/reports/mcd/service/voice',
      name: 'VOICE',
      meta: { id: 'reports-voice' },
      component: () => import('./voice.vue'),
      ...addPermissionsToRoute(['voice']),
    },
    {
      path: '/reports/mcd/service/dtTimer',
      name: 'DT Timer',
      meta: { id: 'reports-dtTimer' },
      component: () => import('./dtTimer.vue'),
      ...addPermissionsToRoute(['serviceTimesStatistics']),
      tags: ['Drive Thru'],
    },
    {
      path: '/reports/mcd/service/customerFeedback',
      name: 'Customer Feedback',
      meta: { id: 'reports-customerFeedback' },
      component: () => import('/src/views/standard/service/CustomerFeedback.vue'),
      ...addPermissionsToRoute(['customerFeedback']),
    },
  ]
};

export default routes;
